import { API } from 'lib';
import { INTEGRATIONS_ENDPOINTS } from 'constant';
import { AxiosResponse } from 'axios';
import { MutationFunction } from '@tanstack/react-query';
import { IXeroSignUpFormReqParams, IXeroSignUpResponse } from '../types';

export const fetchXeroSignupUrl = async (options: { signal: AbortSignal }) => {
  const { data } = await API.get<IXeroSignUpResponse>(
    INTEGRATIONS_ENDPOINTS.GET_XERO_SIGNUP_URL,
    {
      signal: options.signal,
    },
  );
  return data;
};

export const updateXeroSignupForm: MutationFunction<
  AxiosResponse,
  IXeroSignUpFormReqParams
> = async (data) =>
  API.post(`${INTEGRATIONS_ENDPOINTS.UPDATE_XERO_SIGNUP_FORM}/${data?.id}/`, {
    ...data,
  });
